var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main reg"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"reg__content"},[(_vm.loading)?_c('LoadingIndicator',{staticClass:"form-loading"}):_c('h4',{staticClass:"confirm-email__title"},[_vm._v(_vm._s(_vm.message))])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }